<div>
  <form [formGroup]="shareWeeklyConsolForm">
    <mat-card>
      <mat-card-content>

        <mat-form-field appearance="fill" class="compact-field">
          <mat-label>From Date</mat-label>
          <input (click)="picker.open()" matInput [matDatepicker]="picker"
            formControlName="fromDate" placeholder="From Date" autocomplete="off" readonly
            (dateChange)="onDateSelected($event.value)">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <!-- <mat-icon matSuffix class="small-clear-icon">clear</mat-icon> -->
            @if (shareWeeklyConsolForm.get('fromDate')?.touched && shareWeeklyConsolForm.get('fromDate')?.hasError('required')) {
              <mat-error
                >
                From Date is required
              </mat-error>
            }
          </mat-form-field>

          <!-- <mat-form-field class="mat-width">
          <mat-label>To</mat-label>
          <input matInput [value]="shareWeeklyConsolForm.get('toDate')?.value | date:'dd-MM-yyyy'" readonly>
        </mat-form-field> -->

        <mat-form-field appearance="fill" class="compact-field">
          <mat-label>POL</mat-label>
          <mat-select placeholder="POL" (selectionChange)="setPolValueChangeEvent($event.value)"
            formControlName="polId" required>
            <mat-option>
              <ngx-mat-select-search [searching]="searching" [formControl]="polSearchCtrl"
                noEntriesFoundLabel="'no matching found'" placeholderLabel=" Search Port Of Loading(POL)">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            @for (pol of filteredPol | async; track pol) {
              <mat-option [value]="pol.id">
                {{pol.name}} ({{pol.code}})
              </mat-option>
            }
          </mat-select>
          @if ( polId.touched  && polId.hasError('required')) {
            <mat-error>
              POL is required
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="fill" class="compact-field">
          <mat-label>Destination</mat-label>
          <mat-select placeholder="Destination" [formControl]="destinationIdFilterCtrl">
            <mat-option>
              <ngx-mat-select-search [searching]="searching" [formControl]="destinationSearchCtrl"
                noEntriesFoundLabel="No matching destination found" placeholderLabel="Search Destination">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            @for (dest of filteredDestinations | async; track dest) {
              <mat-option [value]="dest.id">
                {{dest.name}} ({{dest.code}})
              </mat-option>
            }
          </mat-select>
          @if (destinationIdFilterCtrl.value) {
            <button mat-icon-button matSuffix
              (click)="$event.stopPropagation(); destinationIdFilterCtrl.setValue(null)"
              matTooltip="Clear" style="width:24px;height:24px;line-height:24px;">
              <mat-icon style="font-size:16px;width:16px;height:16px;line-height:16px;">close</mat-icon>
            </button>
          }
        </mat-form-field>

        <button mat-raised-button color="primary" class="send-planning-btn" (click)="openEmailDialog()"
          matTooltip="Send weekly planning via email" matTooltipPosition="right">
          Share Planning <mat-icon iconPositionEnd>share</mat-icon>
        </button>

        <div class="export-actions-bar">
          <div class="planning-header">
            <mat-icon>fact_check</mat-icon>
            <span class="planning-title">Consol Planning Details</span>
          </div>

          @if (columnFilterOpen) {
            <div class="col-filter-backdrop" (click)="columnFilterOpen = false"></div>
          }
          <div class="col-filter-wrapper">
            <button class="col-filter-btn" (click)="toggleColumnFilter()" matTooltip="Toggle column visibility"
              matTooltipPosition="above">
              <mat-icon>view_column</mat-icon>
              <span>Column filters</span>
              <mat-icon class="col-filter-arrow">{{ columnFilterOpen ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
            </button>
            @if (columnFilterOpen) {
              <div class="col-filter-dropdown">
                <div class="col-filter-dropdown-header">
                  <span class="col-filter-title">Toggle Columns</span>
                  <button mat-button color="warn" class="col-filter-clear-btn" (click)="clearColumnFilter()">Clear All</button>
                </div>
                <div class="col-filter-list">
                  @for (col of columnOptions; track col) {
                    <div class="col-filter-item">
                      <mat-checkbox [checked]="visibleColumnKeys.has(col.key)" (change)="toggleColumnVisibility(col.key)">
                        {{ col.label }}
                      </mat-checkbox>
                    </div>
                  }
                </div>
              </div>
            }
          </div>

          <span class="download_image" [class.download-action--loading]="isGeneratingImage" (click)="!isGeneratingImage && downloadPlanningImage()" matTooltip="Download Planning Image" matTooltipPosition="above">
            @if (!isGeneratingImage) {
              <span>Download Image</span>
              <mat-icon>file_download</mat-icon>
            }
            @if (isGeneratingImage) {
              <mat-spinner diameter="16" color="primary"></mat-spinner>
              <span>Generating Image...</span>
            }
          </span>

          <span class="export-action" (click)="downloadWeeklyPlanning()" matTooltip="Download Excel"
            matTooltipPosition="above">
            <span class="export-action__label">Export Excel</span>
            <mat-icon>file_download</mat-icon>
          </span>
        </div>


        <!-- Image Template (off-screen, captured by html2canvas) -->
        <div #planningTemplate class="planning-template">

          <!-- HEADER -->
          <div class="planningTemplate-header">
            <div class="planningTemplate-company-section">
              <img src="assets\img\grt_logo_final.png" class="planningTemplate-logo">
              <div>
                <div class="planningTemplate-company-title">GRT GLOBAL</div>
                <div class="planningTemplate-company-subtitle">LOGISTICS PVT. LTD.</div>
              </div>
            </div>
            <!-- <div class="planningTemplate-export-box">LCL EXPORTS</div> -->
          </div>

          <!-- TITLE -->
          <div class="planningTemplate-title">◆ CONSOL PLANNING ◆</div>

          <!-- TABLE -->
          <table class="planningTemplate-table">
            <thead>
              <tr>
                <th>PORT NAME</th>
                <th>VESSEL</th>
                <th>STUFFING</th>
                <th>SAILING</th>
              </tr>
            </thead>
            <tbody>
              @for (row of planningImageData; track row) {
                <tr>
                  <td [class.planningTemplate-tba]="!row.destination">{{ row.destination || 'TBA' }}</td>
                  <td [class.planningTemplate-tba]="!row.vesselName">{{ row.vesselName || 'TBA' }}</td>
                  <td [class.planningTemplate-tba]="!row.stuffingDate">{{ row.stuffingDate ? (row.stuffingDate | date:'dd-MM-yyyy') : 'TBA' }}</td>
                  <td [class.planningTemplate-tba]="!row.sailingDate">{{ row.sailingDate ? (row.sailingDate | date:'dd-MM-yyyy') : 'TBA' }}</td>
                </tr>
              }
            </tbody>
          </table>

          <!-- FOOTER -->
          <div class="planningTemplate-footer">
            <div>
              <div class="planningTemplate-footer-title">&#128205; CARTING POINT</div>
              @for (line of cartingAddressLines; track $index) {
                <div>{{ line }}</div>
              }
            </div>
            <div>
              <div class="planningTemplate-footer-title">&#9742; JWR CONTACT PERSON</div>
              @for (line of cartingContactLines; track $index) {
                <div>{{ line }}</div>
              }
            </div>
          </div>

          <!-- CUSTOMER SERVICE BAR -->
          <div class="planningTemplate-cs-bar">
            <div class="planningTemplate-cs-title">&#9743; CUSTOMER SERVICE</div>
            <div class="planningTemplate-cs-contacts">
              <div class="planningTemplate-contact">
                <span class="planningTemplate-contact-num">1</span>
                <span class="planningTemplate-contact-name">Prasad Sangeshkar</span>
                <span class="planningTemplate-contact-phone">8655822463</span>
                <span class="planningTemplate-contact-email">cs4&#64;grtship.com</span>
              </div>
              <div class="planningTemplate-contact">
                <span class="planningTemplate-contact-num">2</span>
                <span class="planningTemplate-contact-name">Sangeeta Prajapati</span>
                <span class="planningTemplate-contact-phone">9987997086</span>
                <span class="planningTemplate-contact-email">cs10&#64;grtship.com</span>
              </div>
              <div class="planningTemplate-contact">
                <span class="planningTemplate-contact-num">3</span>
                <span class="planningTemplate-contact-name">Ruchi Gupta</span>
                <span class="planningTemplate-contact-phone">7718952571</span>
                <span class="planningTemplate-contact-email">cs5&#64;grtship.com</span>
              </div>
            </div>
          </div>

        </div>


        <div class="mat-elevation-z8">
          <table mat-table formArrayName="planningDetails" [dataSource]="weeklyDetailsDataSource | async">

            <ng-container matColumnDef="copyRow">
              <th mat-header-cell *matHeaderCellDef>
                <mat-icon class="copy-header-icon" matTooltip="Copy selected rows"
                (click)="copySelectedRowsToClipboard()" style="cursor:pointer;">assignment</mat-icon>
              </th>
              <td mat-cell *matCellDef="let element">
                <button mat-icon-button (click)="copyRowToClipboard(element)"
                  matTooltip="Copy row to clipboard" matTooltipPosition="right"
                  class="copy-row-btn">
                  <mat-icon class="copy-row-icon">content_copy</mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="destination">
              <th mat-header-cell *matHeaderCellDef>
                <span class="sort-header" (click)="sortByDestination()">
                  Destination
                  <mat-icon class="sort-icon">
                    {{ destinationSortDirection === 'asc' ? 'arrow_upward' : destinationSortDirection === 'desc' ? 'arrow_downward' : 'unfold_more' }}
                  </mat-icon>
                </span>
                <div class="search_filter">
                  <input matInput placeholder="Search Destination" [formControl]="destinationFilterCtrl">
                </div>
              </th>
              <td mat-cell *matCellDef="let element; let i = index">
                <span class="readonly-text">{{ getDestinationName(element) }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="vesselVoyage">
              <th mat-header-cell *matHeaderCellDef>Vessel / Voyage
                <div class="search_filter">
                  <input matInput placeholder="Search Vessel Voyage" [formControl]="vesselVoyageFilterCtrl">
                </div>
              </th>
              <td mat-cell *matCellDef="let element; let i = index">
                <span class="readonly-text">{{ getVesselVoyageName(element) }}</span>
              </td>
            </ng-container>

            <!-- Haz Planning -->
            <ng-container matColumnDef="hazPlanning">
              <th mat-header-cell *matHeaderCellDef>Planning Type</th>
              <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="getRowIndex(element)">
                {{ element.get('isHaz')?.value ? 'HAZ' : 'Non-HAZ'}}
              </td>
            </ng-container>

            <!-- Approx Transit Time -->
            <ng-container matColumnDef="transitTime">
              <th mat-header-cell *matHeaderCellDef>Approx Transit Time</th>
              <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="getRowIndex(element)">
                {{ element.get('transitTime')?.value ? element.get('transitTime')?.value + ' Days' : '- - -' }}
              </td>
            </ng-container>

            <!-- Tentative Stuffing Date -->
            <ng-container matColumnDef="tentativeStuffingDate">
              <th mat-header-cell *matHeaderCellDef>
                <span class="sort-header" (click)="sortByTentativeStuffingDate()">
                  Tentative Stuffing
                  <mat-icon class="sort-icon">
                    {{ tentativeStuffingDateSortDirection === 'asc' ? 'arrow_upward' : tentativeStuffingDateSortDirection === 'desc' ? 'arrow_downward' : 'unfold_more' }}
                  </mat-icon>
                </span>
                <div class="search_filter">
                  <input matInput placeholder="Search Date" [formControl]="stuffingDateFilterCtrl">
                </div>
              </th>
              <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="getRowIndex(element)">
                {{ element.get('tentativeStuffingDate')?.value ? (element.get('tentativeStuffingDate')?.value | date:'dd-MM-yyyy, EEEE') : '- - -' }}
              </td>
            </ng-container>

            <!-- Port Cutoff -->
            <ng-container matColumnDef="portCutoff">
              <th mat-header-cell *matHeaderCellDef>Port Cutoff</th>
              <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="getRowIndex(element)">
                {{ element.get('portCutoff')?.value ? (element.get('portCutoff')?.value | date:'dd-MM-yyyy') : '- - -' }}
              </td>
            </ng-container>

            <!-- Haz Cutoff -->
            <ng-container matColumnDef="hazCutoff">
              <th mat-header-cell *matHeaderCellDef>Haz Cutoff</th>
              <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="getRowIndex(element)">
                {{ element.get('hazCutoff')?.value ? (element.get('hazCutoff')?.value | date:'dd-MM-yyyy') : '- - -' }}
              </td>
            </ng-container>

            <!-- SI Cutoff -->
            <ng-container matColumnDef="siCutoff">
              <th mat-header-cell *matHeaderCellDef>SI Cutoff</th>
              <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="getRowIndex(element)">
                {{ element.get('siCutoff')?.value ? (element.get('siCutoff')?.value | date:'dd-MM-yyyy') : '- - -' }}
              </td>
            </ng-container>

            <!-- ETD POL -->
            <ng-container matColumnDef="etdPol">
              <th mat-header-cell *matHeaderCellDef>
                <span class="sort-header" (click)="sortByEtdPol()">
                  ETD POL
                  <mat-icon class="sort-icon">
                    {{ etdPolSortDirection === 'asc' ? 'arrow_upward' : etdPolSortDirection === 'desc' ? 'arrow_downward' : 'unfold_more' }}
                  </mat-icon>
                </span>
              </th>
              <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="getRowIndex(element)">
                {{ element.get('etdPol')?.value ? (element.get('etdPol')?.value | date:'dd-MM-yyyy') : '- - -' }}
              </td>
            </ng-container>

                        <!-- Routing -->
                        <ng-container matColumnDef="routingId">
                            <th mat-header-cell *matHeaderCellDef>Routing
                               <div class="search_filter">
                                    <input matInput placeholder="Search Destination" [formControl]="routingIdFilterCtrl">
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let element; let i = index">
                                <span class="readonly-text">{{ getRoutingIdName(element) }}</span>
                            </td>
                        </ng-container>

            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <div class="select-header">
                  <mat-checkbox [checked]="selectAll" (change)="toggleSelectAll($event)"
                    matTooltip="Select All">
                  </mat-checkbox>
                  @if (getSelectedCount() > 0) {
                    <span class="selected-count">
                      {{ getSelectedCount() }}
                    </span>
                  }
                </div>
              </th>
              <td mat-cell *matCellDef="let element" [formGroup]="element">
                @if (element.get('status')?.value && !['CANCELLED','PLANNING_COMPLETED'].includes(element.get('status')?.value)) {
                  <mat-checkbox class="fx-align-center-center" formControlName="select"
                    matTooltip="Select">
                  </mat-checkbox>
                }
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="weeklyColumns" class="blue-header"></tr>
            <tr mat-row *matRowDef="let row; columns: weeklyColumns;"></tr>
          </table>
        </div>

        @if (noDataAvailable) {
          <div class="no-data-banner">
            <div class="no-data-banner__icon-wrap">
              <mat-icon>event_busy</mat-icon>
            </div>
            <div class="no-data-banner__body">
              <span class="no-data-banner__title">No Planning Found</span>
              <span class="no-data-banner__message">No planning data available for the selected <strong>Week</strong> and
              <strong>POL</strong>. Please try a different combination.</span>
            </div>
          </div>
        }

        <!-- <mat-card-actions>
        <span fxLayout="column" *ngIf="id.value">
          <span fxLayout="row" fxLayoutGap="16px">
            <span class="p-2">
              <mat-checkbox (change)="canViewLogs($event)" fxLayoutAlign="center center">
                View Log
              </mat-checkbox>
            </span>
          </span>
          <app-history *ngIf="isLogVisible" [referenceType]="'POST_STUFF_PHYSICAL_STUFFING'"
          [referenceId]="id.value"></app-history>
        </span>
        *ngIf="getSaveDisableCondn()"
        *ngIf="isRevertBtn"

        <button mat-button color="primary" (click)="onSave()" *ngIf="shareWeeklyConsolForm.dirty">Save</button>
        <button mat-button color="cancel" *ngIf="id?.value" (click)="onRevert()">Revert Process</button>
      </mat-card-actions> -->

    </mat-card-content>
  </mat-card>
</form>
</div>
